export default "__VITE_ASSET__DpPEsZch__"